import useGlobalStore from "stores/global"
import PostCard from "./PostCard"
import { AppInterface } from "types/types"
import { AdUnit } from "next-google-adsense"

type Props = {
  app: AppInterface
  index: number
}

function Post({ app, index }: Props) {
  const showAds = useGlobalStore((state) => state.showAds)

  return (
    <div className="mx-n3">
      <PostCard
        app={app}
        key={`${index}${app.trackId}${app?.submitters?.[0]?.uid}`}
        uid={app?.submitters?.[0]?.uid}
        id={index?.toString()}
        displayName={app?.submitters?.[0]?.displayName}
        photoURL={app?.submitters?.[0]?.photoURL}
        lastModified={app?.submitters?.[0]?.lastModified}
        submitterDescription={app?.submitters?.[0]?.submitterDescription}
        translatedDescription={app?.submitters?.[0]?.translatedDescription}
        media={app?.submitters?.[0]?.other?.tweet?.media}
      />
      {showAds && index % 4 === 0 && (
        <>
          <div className="card content rounded-m overflow-hidden mt-n3 mb-3">
            <AdUnit
              slotId="4658246641"
              layout="display"
              publisherId="pub-8210764995783356"
            />
          </div>
        </>
      )}
    </div>
  )
}

export default Post
